@if (active) {
    <cl-dialogue
        [title]="'Map settings'"
        [primaryButtonText]="'Apply'"
        (primaryButtonClicked)="applySettings()"
        [secondaryButtonText]="'Cancel'"
        (secondaryButtonClicked)="close()"
        (closed)="close()"
    >
        @if (viewEnum === ViewEnum.Inspect) {
            <div>
                <div class="m10"><strong>Nearby projects</strong></div>
                <div class="m10">
                    <cl-radio
                        [label]="'All nearby projects'"
                        [(ngModel)]="nearbyProjectTypeFilter"
                        [value]="NearbyProjectTypeFilterEnum.All"
                    ></cl-radio>
                </div>
                <div class="m10">
                    <cl-radio
                        [label]="'Only nearby sales projects'"
                        [(ngModel)]="nearbyProjectTypeFilter"
                        [value]="NearbyProjectTypeFilterEnum.SalesOnly"
                    ></cl-radio>
                </div>
                <div class="m20">
                    <cl-radio
                        [label]="'No nearby projects'"
                        [(ngModel)]="nearbyProjectTypeFilter"
                        [value]="NearbyProjectTypeFilterEnum.None"
                    ></cl-radio>
                </div>
            </div>
        }
        <div class="m10"><strong>Map details</strong></div>
        <div class="m10">
            <cl-checkbox label="Labels" [(ngModel)]="selectedMapDetails.labels"></cl-checkbox>
        </div>
        <div class="m10">
            <cl-checkbox label="Placemarks" [(ngModel)]="selectedMapDetails.placemarks"></cl-checkbox>
        </div>
        @if (subViewEnum === PlantAssetsMapParentView.DirectionalSettings) {
            <div>
                <div class="m10">
                    <cl-checkbox label="Rotor diameter" [(ngModel)]="selectedMapDetails.rotorDiameter"></cl-checkbox>
                </div>
                <div class="m10">
                    <cl-checkbox
                        label="Loads indicators"
                        [(ngModel)]="selectedMapDetails.loadsIndicators"
                    ></cl-checkbox>
                </div>
                <div class="m20">
                    <cl-checkbox label="Wind sectors" [(ngModel)]="selectedMapDetails.windSectors"></cl-checkbox>
                </div>
            </div>
        }
        @if (subViewEnum !== PlantAssetsMapParentView.DirectionalSettings) {
            <div class="m10"></div>
        }
        <div class="m10"><strong>Map type</strong></div>
        <pd-map-type-selector
            [changeTilesEmitter]="tileChangeEmitter"
            (mapTilesChanged)="mapTilesChanged($event)"
            [wide]="true"
        ></pd-map-type-selector>
    </cl-dialogue>
}
